<template>
    <div class="bg-silver mt-0 mt-md-1">

        <div class="block-filter">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 ">
                        <a class=" d-block d-md-none text-decoration-none" href="#">
                            <h4 class="mb-3 select-mobile bold pb-2" id="select-filter">
                                Filter het overzicht
                                <div class="float-right row-down">&#9660;</div>
                                <div class="float-right row-up "> &#9650;</div>
                            </h4>
                        </a>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 ">
                        <h5 class="mb-1 d-none d-md-block">
                            Filter het overzicht
                        </h5>
                    </div>

                </div>
            </div>
            <div class="col-12 select-mobile-options">
                <form @submit.prevent="searchDiscountMutations" ref="form">
                    <div class="row">

                        <div class="col-12 col-sm-6 col-lg-4 mb-4">
                            <select2-multiple-control
                                :options="stations"
                                :settings="{placeholder: stationNameCode}"
                                v-model="selectedStations"
                            />
                        </div>


                        <div class="col-12 col-sm-6 col-lg-4 mb-4">
                            <select2-multiple-control
                                :options="products"
                                :settings="{placeholder: fuelName}"
                                v-model="selectedProducts"
                            />
                        </div>

                        <div class="col-12 col-sm-6 col-lg-4 mb-4">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input brands js-brands"
                                       id="activeFuels" value="1" v-model="activeFuels" >
                                <label class="custom-control-label pl-2 " for="activeFuels">
                                    Actieve brandstoffen
                                </label>
                            </div>
                        </div>

                    </div>

                    <div class="form-group  row">
                        <div class="col-12 col-md-8 order-2  order-md-1 ">
                            <button class="btn btn-red m-0" id="search" type="submit">
                                Invoeren
                                <i class="avia-icons-arrow-left"></i>
                            </button>
                        </div>

                    </div>
                </form>

            </div>
        </div>

    </div>
</template>

<script>

export default {

    props: {
        products: Array,
        stations: Array,
        isConfirmed: Boolean
    },
    watch: {
        isConfirmed(newVal) {
            if (newVal) {
                this.emptyFilter();
                this.searchDiscountMutations();
            }
        },
        activeFuels(newVal) {
            this.$emit('showHideFuels', newVal);
        }
    },
    data() {
        return {
            stationNameCode: "Stationsnaam of -code",
            fuelName: 'Brandstofnaam',
            selectedProducts: [],
            selectedStations: [],
            oldSelectedProducts: [],
            oldSelectedStations: [],
            activeFuels: true
        };
    },

    methods: {
        searchDiscountMutations() {
            this.$emit('getDiscountMutations', [this.selectedProducts, this.selectedStations,
                this.oldSelectedProducts, this.oldSelectedStations]);
            this.oldSelectedProducts = this.selectedProducts;
            this.oldSelectedStations = this.selectedStations;
        },
        emptyFilter() {
            this.selectedProducts = [];
            this.selectedStations = [];
            this.$emit('emptyFilterProductsStations', []);
        }
    }

}
</script>


